import { Col, Row, Spinner } from 'react-bootstrap'
import style from './Loading.module.scss'
import React from "react";

export const LOADING = () => {
    return (
        <Row className={style.rowSpinner}>
            <Col lg={12} className={style.contentSpinner}>
                <Spinner animation="border" variant="primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </Col>
        </Row>
    )
}